import * as React from "react";
import { useState } from "react";
import Typography from "@mui/material/Typography";
import LoginRoundedIcon from "@mui/icons-material/LoginRounded";
import ClosedCaptionIcon from "@mui/icons-material/ClosedCaption";
import LocalMoviesIcon from "@mui/icons-material/LocalMovies";
import { Button, Box } from "@mui/material";
import LoginMenu from "./user-login/loginMenu";
import { useContext } from "react";
import MainContext from "../context/mainContext";
import Fab from "@mui/material/Fab";
import FullscreenIcon from "@mui/icons-material/Fullscreen";
import useMediaQuery from "@mui/material/useMediaQuery";
import PaletteIcon from "@mui/icons-material/Palette";
import { ReactComponent as LogoSvg } from "../assets/logo.svg";
import RttIcon from "@mui/icons-material/Rtt";
import TonalityIcon from "@mui/icons-material/Tonality";

function ToolbarButtons(props) {
  const detectSize600px = useMediaQuery("(min-width:600px)");
  const detectSize715px = useMediaQuery("(min-width:715px)");
  const {
    handleFullScreen,
    mainPageNumber,
    handlePageNumber,
    handleOpenSelectVideoBox,
    handleShowSubtitleStyleBox,
    handleOpenSelectSubtitlesBox,
    handleSemiAutoShadowing,
    removeSubtitlesTracks,
  } = props;
  const {
    handleOpenSignInBox,
    userTypes,
    videoInfo,
    handleSubtitleTimeShiftBox,
    subtitleTimeShiftBox,
    handleVideoInfo,
  } = useContext(MainContext);

  return (
    <>
      <Typography sx={{ flexGrow: 1 }}>
        <Button
          variant="contained"
          component="label"
          sx={{ ml: 1 }}
          endIcon={<LocalMoviesIcon />}
        >
          <input
            hidden
            id="videoFile"
            name="videoFile"
            type="file"
            onChange={(event) => {
              handleVideoInfo({
                videoFile: URL.createObjectURL(event.target.files[0]),
                fileName: event.target.files[0]["name"],
                filmName: event.target.files[0]["name"].slice(0, 8),
              });
              handleOpenSelectVideoBox();
              removeSubtitlesTracks();
            }}
          />
          انتخاب فیلم
        </Button>
        {videoInfo.videoFile && mainPageNumber == 0 ? (
          <>
            <Button
              variant="contained"
              onClick={handleOpenSelectSubtitlesBox}
              color={"warning"}
              endIcon={<ClosedCaptionIcon />}
              sx={{ mx: 1 }}
            >
              <Box
                sx={{
                  m: 0,
                  p: 0,
                  display: {
                    xs: "none",
                    sm: "block",
                    md: "block",
                    lg: "block",
                    xl: "block",
                  },
                }}
              >
                انتخاب و تغییر زیرنویس
              </Box>
            </Button>
            <Fab
              onClick={handleShowSubtitleStyleBox}
              id="fullScrenToggleButton"
              size="small"
              color={"warning"}
              variant="extended"
              sx={{ mx: 0.1 }}
            >
              <PaletteIcon />
            </Fab>
            <Fab
              onClick={() => {
                handleSubtitleTimeShiftBox(!subtitleTimeShiftBox);
              }}
              id="fullScrenToggleButton"
              size="small"
              color={"warning"}
              variant="extended"
            >
              <RttIcon />
            </Fab>
            <Fab
              onClick={() => {
                handleSemiAutoShadowing("showSettings", true);
              }}
              id="fullScrenToggleButton"
              size="small"
              color={"warning"}
              variant="extended"
            >
              <TonalityIcon />
            </Fab>
            <Fab
              onClick={handleFullScreen.enter}
              id="fullScrenToggleButton"
              size="small"
              color={"warning"}
              variant="extended"
            >
              <FullscreenIcon />
            </Fab>
          </>
        ) : null}
      </Typography>
      <LogoSvg style={{ display: detectSize715px ? "block" : "none" }} />
      <Button
        sx={{ color: "white", display: detectSize715px ? "block" : "none" }}
        onClick={() => {
          handlePageNumber("", 8);
        }}
      >
        تماس با ما
      </Button>
      {userTypes.length > 0 ? (
        <LoginMenu handlePageNumber={handlePageNumber} />
      ) : (
        <Button
          variant="contained"
          color="secondary"
          onClick={handleOpenSignInBox}
          endIcon={<LoginRoundedIcon />}
          sx={{ mx: detectSize600px ? 2 : 0 }}
        >
          {detectSize600px ? "ورود" : ""}
        </Button>
      )}
    </>
  );
}

export default ToolbarButtons;
